import React, { FC, useEffect, useState } from 'react';

import { Match, MatchPlayMatchTeams, PlayerResult, TeamGameMatch, TeamGameMatchTeam } from '../../../../../database.schema';
import { MatchDayTeamGamesResultScoreCard, useFetchMatchDayTeamGamesResultScoreCard } from '../../../../api/hooks/use-fetch-match-day-results-with-scorecard';
import { useParams } from 'react-router-dom';
import { HandicapEntry } from '../../handicaps/ryder-cup/handicap-entry';
import { HoleScores } from '../../scores/ryder-cup/hole-scores';
import { TeamGameMatchPlayScoreCard } from '../../score-card/team-game-match-play-score-card';
import { getPlayerScore } from '../../../../utils/score-calculator';

type EnterMatchPlayScoreCardProps = {
  editing: boolean;
};

export const EnterTeamGameMatchPlayScoreCard: FC<EnterMatchPlayScoreCardProps> = ({ editing }): JSX.Element => {
  let params = useParams();
  const tournamentIndex = Number(params.tournamentIndex);
  const dayIndex = Number(params.dayIndex);
  const teamIndex = Number(params.teamIndex);
  const { isLoading, error, data } = useFetchMatchDayTeamGamesResultScoreCard(tournamentIndex, dayIndex);
  const { config, course, match, startingHole } = data as MatchDayTeamGamesResultScoreCard;
  const [teamGameMatchStore, setTeamGameMatchStore] = useState<TeamGameMatch>({
    ...match,
  });
  const [ryderCupMatchStore, setRyderCupMatchStore] = useState<Match>();
  const [matchPlayTeams, setMatchPlayerTeams] = useState<MatchPlayMatchTeams>();
  const [showHandicapEntry, setShowHandicapEntry] = useState(true);
  const [showScoreEntry, setShowScoreEntry] = useState(true);

  useEffect(() => {
    if (match && match.matchPlayMatches) {
      const teamGameMatch: Match = { date: '', team1: { players: [], points: 0 }, team2: { players: [], points: 0 }, resultByHole: [], resultMargin: '' };
      match.matchPlayMatches[teamIndex].team1.playerIds.forEach((playerId) => {
        const player = match.teams[0].players.find((matchPlayer) => matchPlayer.playerId === playerId);
        if (player) {
          // const individualHandicap = player.round.individualHandicap === -1 ? 18 : player.round.individualHandicap;
          // const shotsReceived = player.round.shotsReceived === -1 ? 5 : player.round.shotsReceived;
          // teameGameMatch.team1.players.push({ ...player, round: { ...player.round, individualHandicap, shotsReceived } });
          teamGameMatch.team1.players.push({ ...player });
        }
      });
      match.matchPlayMatches[teamIndex].team2.playerIds.forEach((playerId) => {
        const player = match.teams[1].players.find((matchPlayer) => matchPlayer.playerId === playerId);
        if (player) {
          // const individualHandicap = player.round.individualHandicap === -1 ? 18 : player.round.individualHandicap;
          // const shotsReceived = player.round.shotsReceived === -1 ? 5 : player.round.shotsReceived;
          // teameGameMatch.team2.players.push({ ...player, round: { ...player.round, individualHandicap, shotsReceived } });
          teamGameMatch.team2.players.push({ ...player });
        }
      });
      if (match.matchPlayMatches[teamIndex].resultMargin && match.matchPlayMatches[teamIndex].resultMargin !== '') {
        teamGameMatch.resultMargin = match.matchPlayMatches[teamIndex].resultMargin;
        teamGameMatch.resultByHole = match.matchPlayMatches[teamIndex].resultByHole;
      }
      setRyderCupMatchStore({ ...teamGameMatch });
    }
  }, [data, match]);

  const convertMatchBackToTeamGameMatch = (): TeamGameMatch => {
    const team1Players = [...teamGameMatchStore.teams[0].players];
    const team2Players = [...teamGameMatchStore.teams[1].players];
    ryderCupMatchStore?.team1.players.forEach((player: PlayerResult) => {
      const team1Index = team1Players.findIndex((t1Player) => t1Player.playerId === player.playerId);
      if (team1Index > -1) {
        team1Players.splice(team1Index, 1, { ...player, points: getPlayerScore(player.round.individualHandicap, player.round.scoreCard, course, startingHole) });
      }
    });
    ryderCupMatchStore?.team2.players.forEach((player: PlayerResult) => {
      const team2Index = team2Players.findIndex((t2Player) => t2Player.playerId === player.playerId);
      if (team2Index > -1) {
        team2Players.splice(team2Index, 1, { ...player, points: getPlayerScore(player.round.individualHandicap, player.round.scoreCard, course, startingHole) });
      }
    });
    const teamMatchTeam1: TeamGameMatchTeam = {
      ...teamGameMatchStore.teams[0],
      players: [...team1Players],
      scoresEntered: team1Players.every((player) => player.round.individualHandicap > -1),
    };
    const teamMatchTeam2: TeamGameMatchTeam = {
      ...teamGameMatchStore.teams[1],
      players: [...team2Players],
      scoresEntered: team2Players.every((player) => player.round.individualHandicap > -1),
    };
    return { ...teamGameMatchStore, teams: [{ ...teamMatchTeam1 }, { ...teamMatchTeam2 }] };
  };

  if (showHandicapEntry && ryderCupMatchStore) {
    const editingMatch = ryderCupMatchStore.team1.players.some((player: PlayerResult) => player.round.individualHandicap !== -1);
    return (
      <HandicapEntry
        config={config}
        editingMatch={editingMatch}
        startingHole={startingHole}
        course={course}
        matchIndex={teamIndex}
        recordedMatch={ryderCupMatchStore}
        setRecordedMatch={setRyderCupMatchStore}
        setShowHandicapEntry={setShowHandicapEntry}
        format={'Singles'}
      />
    );
  }
  if (!showHandicapEntry && showScoreEntry && ryderCupMatchStore) {
    return (
      <HoleScores startingHole={startingHole} recordedMatch={ryderCupMatchStore} setRecordedMatch={setRyderCupMatchStore} course={course} setShowScoreEntry={setShowScoreEntry} />
    );
  }

  if (ryderCupMatchStore) {
    return (
      <TeamGameMatchPlayScoreCard
        startingHole={startingHole}
        course={course}
        recordedMatch={ryderCupMatchStore}
        teamGameMatch={convertMatchBackToTeamGameMatch()}
        showScoreEntry={setShowScoreEntry}
        matchIndex={dayIndex}
        teamIndex={teamIndex}
        format="Singles"
      />
    );
  }
  return <div>loading</div>;
};
